import { OrganizationInvitationType } from "@/api";
import { TypographyH3 } from "@/components/typography/H3";
import { TypographyInlineCode } from "@/components/typography/InlineCode";
import { TypographyP } from "@/components/typography/P";
import { AcceptInvitation } from "./AcceptInvitation";
import { RejectInvitation } from "./RejectInvitation";

type Props = {
  invitation: OrganizationInvitationType;
};

export const Invitation = ({ invitation }: Props) => {
  return (
    <div className="flex flex-col gap-6 justify-center items-center w-full">
      <TypographyH3>You&apos;ve been invited!</TypographyH3>
      <TypographyP className="dark:text-brand-gray-50">
        You&apos;ve been invited to join{" "}
        <TypographyInlineCode>
          {invitation.organizationName}
        </TypographyInlineCode>{" "}
        with the role{" "}
        <TypographyInlineCode className="lowercase">
          {invitation.role}
        </TypographyInlineCode>
        .
      </TypographyP>

      <div className="flex gap-4">
        <AcceptInvitation invitationId={invitation.id} />
        <RejectInvitation invitationId={invitation.id} />
      </div>
    </div>
  );
};
